import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';
import FlexSetPage from './flexSets/flexSetPage';

function hydrateCategoryPage() {
    if (typeof window.__PRELOADED_FLEXSET_PAGE_STATE__ !== 'undefined') {
        const data = JSON.parse(JSON.stringify(window.__PRELOADED_FLEXSET_PAGE_STATE__));
        delete window.__PRELOADED_FLEXSET_PAGE_STATE__;
        hydrateRoot(
            document.getElementById('ats-categorypage'),
            <FlexSetPage {...data} suppressHydrationWarning />, {
                onRecoverableError: (error: unknown, errorInfo) => {
                    // eslint-disable-next-line no-console
                    console.error('Hydration error:', error instanceof Error ? error.message : error);
                    // eslint-disable-next-line no-console
                    console.error('Component stack:', errorInfo?.componentStack);
                }
            }
        );
    }
}

hydrateCategoryPage();
